/* User defined models */
import { Month } from './month.model';
import { Year } from './year.model';

export class CardDetail {
  type: string;
  number: string;
  currency: string;
  ccvCode: string;
  firstName: string;
  lastName: string;
  startDate: string;
  expirationDate: string;
  amount: number;
  billingAddressPostalCode: string;
  address: CardDetailAddress;
  email: string;

  constructor(
    type?: string,
    number?: string,
    currency?: string,
    firstName?: string,
    lastName?: string,
    ccvCode?: string,
    selectedYear?: Year,
    selectedMonth?: Month,
    addressLine1?: string,
    addressLine2?: string,
    city?: string,
    stateProvince?: string,
    postalCode?: string,
    countryCode?: string,
    email?: string
  ) {
    this.type = type;
    this.number = number;
    this.currency = currency;

    this.firstName = !!firstName ? firstName.trim() : firstName;
    this.lastName = !!lastName ? lastName.trim() : lastName;
    this.ccvCode = ccvCode;
    this.email = email;

    this.billingAddressPostalCode = !!postalCode ? postalCode.trim() : postalCode;
    if (!!selectedYear && !!selectedMonth) {
      this.expirationDate = `${selectedYear.name}-${selectedMonth.name}`;
    }
    // Adress line 1 is required for the billing address, if it exists then this is a CC and we have a full address
    // SVCS chokes if there is an empty string instead of a null
    if (!!addressLine1) {
      this.address = new CardDetailAddress(
        addressLine1.trim(),
        !!addressLine2 ? addressLine2.trim() : null,
        city.trim(),
        stateProvince !== '-1' ? stateProvince : null,
        postalCode.trim(),
        countryCode
      );
    }
  }
}

export class CardDetailAddress {
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  countryCode: string;

  constructor(
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateProvince: string,
    postalCode: string,
    countryCode: string
  ) {
    this.addressLine1 = addressLine1;
    this.addressLine2 = addressLine2;
    this.city = city;
    this.stateProvince = stateProvince;
    this.postalCode = postalCode;
    this.countryCode = countryCode;
  }
}
